/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { TurJob } from '../../models/tur-job';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetJob$Params {
  jobId: string;
}

export function getJob(
  http: HttpClient,
  rootUrl: string,
  params: GetJob$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TurJob>> {
  const rb = new RequestBuilder(rootUrl, getJob.PATH, 'get');
  if (params) {
    rb.path('jobId', params.jobId, {});
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TurJob>;
    }),
  );
}

getJob.PATH = '/manage/job/{jobId}';
